import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import api from "../services";

export interface OrderItem {
  _id?: string;
  itemId: string;
  name: string;
  kitchenName?: string;
  cartId: string;
  prepTime?: number;
  price: number;
  quantity: number;
    isPartOfDeal?: boolean;  
    dealId?: string;
  originalPrice?: number;
  requestedCustomization?: string;
  discountAmount?: string;
  categoryId?: string;
  imageUrl?: string;
  tax?: number;
  gst?: number;
  pst?: number;
  customOptions?: {
    label: string;
    price: number;
    qty: number;
    isDefault?: boolean;
    groupName?: string;
  }[];
}
type DealType = 'percentage_discount' | 'fixed_price' | 'buy_x_get_y' | 'build_your_own' | 'bundle';

interface AppliedDeal {
  dealId: string;
  claimId?: string;
  originalDealId?: string;
  name: string;
  discountAmount: number;
  dealType: DealType;
  byoBasePrice?: number;
  byoIncludedToppings?: number;
  bundlePrice?: number;
}
interface OrderData {
  items?: OrderItem[];
  totalAmount?: string;
  discountAmount?: string;
  isAsap?: boolean;
  phoneNumber?: string;
  restaurantId?: string;
  appliedDeals?: AppliedDeal[];
  tableToken?: number | string;
  choice?: string; // Dining In / Takeaway
  payChoice?: string; // Pay Here / Counter
  customOptions?: {
    label: string;
    price: number;
    qty: number;
    isDefault?: boolean;
    groupName?: string;
  }[];
  location?: {
    address: string;
    lat: number;
    lng: number;
  };
  // Pickup location details (for pickup orders)
  pickupLocation?: {
    hotelName: string;
    address: string;
    phoneNo: string;
    latitude: number;
    longitude: number;
  };
  scheduledAt?: string; // ISO string of scheduled time
  scheduledTimezone?: string; // IANA timezone identifier (e.g., "America/New_York")
}

interface OrderContextType {
  orderData: OrderData | null;
  setOrderData: React.Dispatch<React.SetStateAction<OrderData | null>>;
  clearOrder: () => void;
  recentOrder: any;
  setRecentOrder: React.Dispatch<React.SetStateAction<any>>;
  fetchOrderStatus: () => void;
    discount: number | null;
  setDiscount: React.Dispatch<React.SetStateAction<number | null>>;
     totalDealDiscount: number | null;
  setTotalDealDiscount: React.Dispatch<React.SetStateAction<number >>;
  resetOrderContext:()=> void;
}

const OrderContext = createContext<OrderContextType | undefined>(undefined);

export const OrderProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [orderData, setOrderData] = useState<OrderData | null>(null);
  const [recentOrder, setRecentOrder] = useState<any>(null);
  const [totalDealDiscount, setTotalDealDiscount] = useState<number>(0)
    const [discount, setDiscount] = useState<number | null>(null);
  const { user } = useAuth();
 const fetchOrderStatus = async () => {
    try {
      console.log("Fetching order status for:", user?.phonenumber);
     const res = await api.get(`/orders/status/${user?.phonenumber}`);
      const data = res.data;

      console.log("APIgggg Response:", data);


       setRecentOrder(data.data);
      
    } catch (error) {
      console.error("Error fetching order status:", error);
    }
  };

  const clearOrder = () => setOrderData(null);

const resetOrderContext = () => {
  console.log("🔥 RESET ORDER CONTEXT DONE");
  setOrderData(null);
  setRecentOrder(null);
};
useEffect(() => {
 console.log("dghjdgjbdgj", totalDealDiscount)
}, [totalDealDiscount])



  return (
    <OrderContext.Provider value={{ orderData, setOrderData, clearOrder , discount, setDiscount ,recentOrder , fetchOrderStatus , setRecentOrder,resetOrderContext, totalDealDiscount, setTotalDealDiscount}}>
      {children}
    </OrderContext.Provider>
  );
};

export const useOrder = () => {
  const context = useContext(OrderContext);
  if (!context) {
    throw new Error("useOrder must be used inside OrderProvider");
  }
  return context;
};
